import { createAsyncThunk } from "@reduxjs/toolkit";
import { createRequest } from "helpers/tools";
import { getSystemFields } from "helpers/systemFields/getSystemFields";

const ENDPOINTS = {
    TRACKER_EVENTS: "events/tracker-events",
    EVENTS_CATALOG: "events",
};

export const getTrackerEventsAsync = createAsyncThunk(
    "trackerEvents/getTrackerEvents",
    async (_, thunkAPI) => {
        const response = await createRequest({
            suffix: ENDPOINTS.TRACKER_EVENTS,
            method: "get",
        });
        if (!response?.status) {
            return thunkAPI.rejectWithValue(response?.message);
        }
        return response.data ?? [];
    },
);

export const getEventsCatalogAsync = createAsyncThunk(
    "trackerEvents/getEventsCatalog",
    async (_, thunkAPI) => {
        const response = await createRequest({
            suffix: ENDPOINTS.EVENTS_CATALOG,
            method: "get",
        });
        if (!response?.status) {
            return thunkAPI.rejectWithValue(response?.message);
        }
        return {
            events: response?.data?.events ?? [],
            filters: response?.data?.filters ?? [],
        };
    },
);

export const getSystemFieldsAsync = createAsyncThunk(
    "trackerEvents/getSystemFields",
    async (_, thunkAPI) => {
        const response = await getSystemFields();
        if (!response?.status) {
            return thunkAPI.rejectWithValue(response?.message);
        }
        return response?.data?.system_fields ?? {};
    },
);
